import { createPlayer as createDplusPlayer, playerConfig, } from "@discovery/sonic-player-dplus";
import * as M from "@discovery/prelude/lib/data/maybe";
export const createPlayer = (read, imaAdsConfig, shortsPage, broadcastType, flags) => {
    const env = read.playerConfig.environment;
    const ENV = env === "prod"
        ? "PROD" /* PROD */
        : env === "uat"
            ? "UAT" /* UAT */
            : "TEST" /* TEST */;
    const baseConfig = playerConfig({ env: ENV });
    const pip = {
        pipEnabled: !imaAdsConfig.enableAds,
    };
    const interactiveMediaEnv = {
        enableAds: imaAdsConfig.enableAds,
        markerDuration: 10,
        vastTag: imaAdsConfig === null || imaAdsConfig === void 0 ? void 0 : imaAdsConfig.vastTag,
        shortsVastTag: imaAdsConfig === null || imaAdsConfig === void 0 ? void 0 : imaAdsConfig.shortsVastTag,
        sampleVastTag: "sampleVastTag",
        showUIElements: false,
        debug: false,
    };
    const theme = {
        isCarousel: false,
        shortsPage: shortsPage ? shortsPage : false,
    };
    const conf = Object.assign(Object.assign({}, baseConfig), { interactiveMediaEnv,
        pip,
        theme, flags: Object.assign(Object.assign(Object.assign({}, baseConfig.flags), flags), {
            autoplay: broadcastType && M.fromMaybe(broadcastType, "") === "LIVE"
                ? false
                : true,
        }), env: {
            APP_NAME: read.sonicApiAppConfig.clientName,
            HOST: read.sonicApiAppConfig.domain,
            SONIC_REALM: read.sonicApiAppConfig.realm,
        }, auth: {
            returnUrl: encodeURIComponent(window.location.href),
            host: read.authService.domain,
        } });
    return createDplusPlayer(Object.assign({}, conf));
};

